import { logEvent } from "firebase/analytics";
import { analytics } from "../firebase";

// Best-effort wrapper: analytics must never break the page it's tracking.
const track = (eventName, params = {}) => {
  try {
    if (analytics) logEvent(analytics, eventName, params);
  } catch (error) {
    console.error(`Analytics event "${eventName}" failed:`, error);
  }
};

export const trackPageView = (pagePath, pageTitle) =>
  track("page_view", { page_path: pagePath, page_title: pageTitle });

export const trackWhatsAppClick = (source) =>
  track("whatsapp_click", { source });

export const trackCallClick = (source) =>
  track("call_click", { source });

export const trackEnquirySubmit = (service) =>
  track("generate_lead", { service, method: "enquiry_form" });

export const trackBrochureDownload = (source) =>
  track("brochure_download", { source });
